import { Route } from '@angular/router';

export const RemitosReportPrintRoute: Route = {
  path: '',
  loadChildren() {
    return import(
      '@daas-consulting/production/remitos_report/frontend/routes'
    ).then((c) => c.RemitosReportPrintRoutes);
  },
};
